import React from 'react'

import { formatTrackCategoryLabel, getTrackPickerState } from './trackPicker'
import {
  TrackAudioFile,
  TracksAudioIndex,
} from '../../../../../firebase/utils/storageActions'
import { LogExercices } from '../../../../../types'
import Button from '../../../../buttons/Button'

import {
  TrackPickerOptions,
  TrackPickerSelect,
  TrackPickerStatus,
  TrackPickerStep,
} from './styles'

interface TrackExercisePickerProps {
  disabled: boolean
  exercise: LogExercices
  index: TracksAudioIndex | null
  loading: boolean
  error?: string | null
  onRetry?: () => void
  onPathChange: (path: string[]) => void
  onTrackChange: (track: TrackAudioFile | null) => void
}

const TrackExercisePicker = ({
  disabled,
  exercise,
  index,
  loading,
  error,
  onRetry,
  onPathChange,
  onTrackChange,
}: TrackExercisePickerProps) => {
  const state = getTrackPickerState(index, exercise)
  const showLoading = loading && !index
  const showEmpty =
    !loading &&
    index !== null &&
    ((state.levels.length === 0 && !state.folderAvailable) ||
      (state.selectionComplete && state.tracks.length === 0))

  return (
    <>
      {state.levels.map((level) => (
        <TrackPickerStep key={level.depth}>
          <legend>{level.legend}</legend>
          <TrackPickerOptions>
            {level.options.map((folderName) => (
              <Button
                key={folderName}
                type="button"
                className={`inline-menu ${
                  level.selected === folderName ? 'active' : ''
                }`}
                disabled={disabled}
                aria-pressed={level.selected === folderName}
                onClick={() =>
                  onPathChange([
                    ...state.selectedPath.slice(0, level.depth),
                    folderName,
                  ])
                }
                label={formatTrackCategoryLabel(folderName)}
              />
            ))}
          </TrackPickerOptions>
        </TrackPickerStep>
      ))}

      {state.tracks.length > 0 && (
        <TrackPickerStep>
          <legend>Track</legend>
          <TrackPickerSelect
            aria-label="Track"
            value={exercise.exercise?.url || ''}
            onChange={(event) =>
              onTrackChange(
                state.tracks.find(
                  (trackItem) => trackItem.url === event.target.value,
                ) ?? null,
              )
            }
            name="exercise"
            disabled={disabled}
            className={exercise.exercise?.url ? 'active' : undefined}
          >
            <option value="">Seleccionar track</option>
            {state.tracks.map((trackItem) => (
              <option key={trackItem.url} value={trackItem.url}>
                {trackItem.title.replace(/\.mp3$/i, '')}
              </option>
            ))}
          </TrackPickerSelect>
        </TrackPickerStep>
      )}

      {showLoading && (
        <TrackPickerStatus role="status">Cargando tracks…</TrackPickerStatus>
      )}
      {!showLoading && error && (
        <TrackPickerStatus role="alert">
          {error}
          {onRetry && (
            <Button
              type="button"
              className="inline-menu"
              onClick={onRetry}
              label="Reintentar"
            />
          )}
        </TrackPickerStatus>
      )}
      {showEmpty && !error && (
        <TrackPickerStatus role="status">
          {state.levels.length === 0
            ? 'No hay carpetas disponibles en tracks/ para este entorno.'
            : 'No hay tracks disponibles para esta selección.'}
        </TrackPickerStatus>
      )}
    </>
  )
}

export default TrackExercisePicker
